import { Divider, SkeletonText, useBoolean } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider, { useStepperContext } from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { usePermissionsContext } from 'contexts/PermissionsContext';
import { CONTENT_GROUP_TYPE_NAMES } from 'features/content-groups/components/ContentGroupsList';
import { useResource } from 'hooks/useResource';
import { useEffect } from 'react';
import { ScrollRestoration, useLocation, useNavigate, useParams } from 'react-router-dom';
import CreateEmailDialog from '../components/CreateEmailDialog';
import { wrapperDialogDefaultProps } from '../config';
import FormCheckData from '../forms/FormCheckData';
import { FormContent } from '../forms/FormContent';
import FormLists from '../forms/FormLists';

const PATH_STEPS = {
  CONTENT_CREATED: 'conteudo',
  LISTS_DEFINED: 'listas',
  DATA_CHECKED: 'conferir-dados'
}

export default function PageEditEmail() {
  const { id = '', step } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { data: content, isFetched } = useResource({ id, resourceName: 'content', path: 'contents' });
  const [alert] = useBoolean();
  const { user } = usePermissionsContext();
  const userRole = user?.role;

  const isSent = !!(content && content.email);

  useEffect(() => {
    if (isSent && (userRole !== 'admin' && userRole !== 'partner')) {
      navigate('/disparos-de-report');
    }
  }, [isSent, navigate, userRole]);

  //useLayoutEffect(() => {
  //   useEffect(() => {
  //   if (content && !step)
  //     navigate(`/disparos-de-report/editar/${id}/${PATH_STEPS[content.step]}`, { replace: true });
  // }, [content]);

  let activeStepIndex = 0;

  if (!isSent && content && step) {
    activeStepIndex = Object.values(PATH_STEPS).findIndex((v) => v === step);
  }

  return (
    <>
      <ScrollRestoration />
      <SkeletonText noOfLines={1} isLoaded={isFetched}>
      { content && (
        <StepperProvider
          steps={['Conteúdo', 'Listas', 'Conferir dados']}
          activeStepIndex={activeStepIndex}
        >
          <CreateEmailDialog defaultIsOpen={alert} />

          <HeaderBarInternal
            title={`Disparo de ${CONTENT_GROUP_TYPE_NAMES[content.contentGroup.type]} - ${content.contentGroup.name}`}
            backTo={`/disparos-de-report${location.search}`}
            dialogProps={wrapperDialogDefaultProps}
          >
            {!isSent && <CustomStepper />}
          </HeaderBarInternal>
          
          <Divider />
          
          <CurrentStep content={content} />
        </StepperProvider>
      )}
      </SkeletonText>
    </> 
  )
}

function CurrentStep({ content }: { content: Record<string, unknown> }) {
  const { activeStep } = useStepperContext();
  if (activeStep === 0)
    return <FormContent isEditing content={content} />;
  
  if (activeStep === 1)
    return <FormLists content={content} />;

  if (activeStep === 2)
    return <FormCheckData content={content} />;
  
  return null;
}
